<template>
  <!-- 单个答卷审核 弹层-->
  <div>
    <el-drawer
      v-if="visible"
      custom-class="examine-drawer overflow-visible"
      :title="drawerTitle"
      :visible.sync="visible"
      @close="closeAuditDetailDialog"
      size="90%"
      :destroy-on-close="true"
      append-to-body
    >
      <div class="prevNext" v-if="!disabledPrevNext">
        <el-button id="prev" type="primary" plain @click="toPrev()">上一条</el-button>
        <el-button id="next" type="primary" plain @click="toNext()">下一条</el-button>
      </div>
      <el-container class="h-full overflow-hidden answer-one-item bg-card-bg-gray">
        <!-- 多个业务公用 myApproved代表【我审核的问卷】功能 -->
        <!-- :style="isEdit || myApproved ? 'height: calc(100% - 60px);' : 'height: 100%;'" -->
        <el-container class="flex-1 overflow-hidden">
          <el-main class="bg-white relative">
            <div v-if="score && score>0" class="text-right absolute" style="top:20px;right:24px">
              <span>总得分: <span class="text-theme ml-2">{{ score }}</span></span>
            </div>
            <el-tabs v-model="currentTab" :before-leave="tabLeave">
              <el-tab-pane name="detail-new">
                <span slot="label" class="flex items-center">
                  <span>新答卷样式</span>
                  <span class="meta-label">Beta</span>
                </span>
                <template v-if="currentTab === 'detail-new'">
                <template v-if="myApproved"
                  ><!--【我审核的问卷】功能isApproved 用接口返回的allowModifyAnswers 判断 是否可编辑 -->
                  <new-question-edit
                    v-if="allowModifyAnswers"
                    ref="newQuestionEdit"
                    :answerId="_currentId"
                    :key="_currentId"
                  />
                  <new-question-show v-else :answerId="_currentId" :key="_currentId" />
                </template>
                <template v-else
                  ><!--【我审核的问卷】功能以外 isApproved 用props参数isEdit判断 是否可编辑 -->
                  <new-question-edit
                    v-if="isEdit"
                    ref="newQuestionEdit"
                    :answerId="_currentId"
                    :key="_currentId"
                  />
                  <new-question-show v-else :answerId="_currentId" :key="_currentId" />
                </template>
                </template>
              </el-tab-pane>
              <el-tab-pane label="看全部问题" name="detail">
                <template v-if="currentTab === 'detail'">
                <template v-if="myApproved"
                  ><!--【我审核的问卷】功能isApproved 用接口返回的allowModifyAnswers 判断 是否可编辑 -->
                  <detail-edit
                    v-if="allowModifyAnswers"
                    :answerId="_currentId"
                    ref="details"
                    :key="_currentId"
                    @loadingEnd="detailLoadingEnd"
                  />
                  <detail-show v-else :answerId="_currentId" ref="details" :key="_currentId" />
                </template>
                <template v-else
                  ><!--【我审核的问卷】功能以外 isApproved 用props参数isEdit判断 是否可编辑 -->
                  <detail-edit
                    v-if="isEdit"
                    :answerId="_currentId"
                    ref="details"
                    :key="_currentId"
                    @loadingEnd="detailLoadingEnd"
                  />
                  <detail-show v-else :answerId="_currentId" ref="details" :key="_currentId" />
                </template>
                <!-- @allquestionlist="getFeikaiArr" -->
                </template>
              </el-tab-pane>
              <el-tab-pane label="只看重点问题" name="main">
<!--                <template v-if="currentTab === 'main'">-->
                <main-questions-table :currentId="_currentId" @getStatus="getStatus" @notCopy="notCopy"></main-questions-table>
<!--                </template>-->
              </el-tab-pane>
              <el-tab-pane label="维度报告" name="dimension" v-if="isDataDownload">
                <dimension-report ref="dimension" :answerId="_currentId"></dimension-report>
              </el-tab-pane>
            </el-tabs>
          </el-main>
          <el-aside width="412px" class="relative overflow-x-hidden">
            <!-- 审批流程 -->
            <!-- <detail-task-flow :currentId="_currentId"></detail-task-flow> -->
            <!-- 修改记录 -->
            <!-- <edit-record :answerId="_currentId" class="absolute top-6 right-20"></edit-record> -->
            <SurveyDetailInfo
              :answerId="_currentId"
              :readonly="!isEdit"
              ref="surveyDetail"
              @audioPlay="audioPlayHandle"
            ></SurveyDetailInfo>
          </el-aside>
        </el-container>

        <!--【分析-审核答卷-已审答卷】功能 或【我审核的问卷】功能 以外的情况 isApproved -->
        <el-footer v-loading="btnsLoading" class="bg-white" v-if="isEdit && !isApproved && !myApproved && !isSmartStore && (source !== 'datalist2')">
          <!-- 非委托代理，待质控0或处理中12的时候 显示 --><!-- 委托代理，待质控0或处理中12或等待一审8的时候 显示 -->
          <div
            class="examine-btn"
            v-if="
              ((auditStatus == 0 || auditStatus == 12) && !preAudit) ||
              ((auditStatus == 0 || auditStatus == 12 || auditStatus == 8) && preAudit)
            "
          >
            <div class="mr-4 flex-1 overflow-hidden">
              <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
            </div>
            <div class="flex items-center">
              <el-button type="text" size="small" @click="saveBtnEvent()" :loading="saveBtn.noLoading">保存答卷</el-button>
              <el-button size="small" type="danger" class="h-8 flex items-center" plain @click="openSingleBtn('reject')" v-if="[2, 7, 9].includes(channel)">
                <span class="align-middle">驳回</span>
                <el-tooltip content="驳回给调查员的答卷，调查员可以修改后重新提交" placement="top" effect="light">
                  <i v-if="isInterview" class="iconfont icon-shuoming text-theme-black-350 cursor-pointer align-middle"></i>
                </el-tooltip>
              </el-button>
              <el-button size="small" class="h-8 flex items-center" plain @click="openSingleBtn('refuse')">
                <span class="align-middle">拒绝</span>
                <el-tooltip content="拒绝的答卷，调查员无法修改" placement="top" effect="light">
                  <i v-if="isInterview" class="iconfont icon-shuoming text-theme-black-350 cursor-pointer align-middle"></i>
                </el-tooltip>
              </el-button>
              <el-button size="small" type="primary" @click="openSingleBtn('agree')">通过</el-button>
            </div>
          </div>
          <div class="examine-btn" v-else>
            <div class="mr-4 flex-1 overflow-hidden">
              <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
            </div>
            <div class="flex items-center">
              <el-button @click="closeAuditDetailDialog">关闭</el-button>
            </div>
          </div>
        </el-footer>
        <!-- 【已审答卷】功能isApproved，已审答卷 还要修改审核状态 -->
        <el-footer v-else-if="isEdit && isApproved && !isSmartStore" class="examine-btn bg-white">
          <div class="mr-4 flex-1 overflow-hidden">
            <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
          </div>
          <div class="flex items-center">
            <el-button size="small" type="primary" @click="openApprovedBtn()" :loading="editBtn.loading">修改审核</el-button>
            <el-button size="small" plain @click="saveBtnEvent()" :loading="saveBtn.noLoading">保存编辑</el-button>
          </div>
        </el-footer>
        <!-- 【此功能等用完后 记得删除】2023-10-19 五指山问卷的定制修改---可以像（【已审答卷】一样，二次编辑答卷），问卷名中包含【五指山】字符串 -->
        <el-footer v-else-if="isEdit && isWuZhiShan && (source === 'datalist2') && !isSmartStore" class="examine-btn bg-white">
          <div class="mr-4 flex-1 overflow-hidden">
            <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
          </div>
          <div class="flex items-center">
            <!-- <el-button size="small" type="primary" @click="openApprovedBtn()" :loading="editBtn.loading">修改审核</el-button> -->
            <el-button size="small" type="primary" @click="saveBtnEvent()" :loading="saveBtn.noLoading">保存编辑</el-button>
          </div>
        </el-footer>
        <!--【我审核的问卷】功能myApproved -->
        <el-footer v-loading="btnsLoading" class="bg-white" v-else-if="myApproved && !isSmartStore">
          <template v-if="!showClose"
            ><!-- 待我处理tab -->
            <div
              class="examine-btn"
              v-if="
                ((auditStatus == 0 || auditStatus == 12) && !preAudit) ||
                ((auditStatus == 0 || auditStatus == 12 || auditStatus == 8) && preAudit)
              "
            >
              <div class="mr-4 flex-1 overflow-hidden">
                <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
              </div>
              <div class="flex items-center">
                <el-button type="text" size="small" @click="saveBtnEvent()" :loading="saveBtn.noLoading" v-if="allowModifyAnswers"
                  >保存答卷</el-button
                >
                <el-button size="small" type="danger" class="h-8 flex items-center" plain @click="openSingleBtn('reject')" v-if="[2, 7, 9].includes(channel)">
                  <span class="align-middle">驳回</span>
                  <el-tooltip content="驳回给调查员的答卷，调查员可以修改后重新提交" placement="top" effect="light">
                    <i v-if="isInterview" class="iconfont icon-shuoming text-theme-black-350 cursor-pointer align-middle"></i>
                  </el-tooltip>
                </el-button>
                <el-button size="small" class="h-8 flex items-center" plain @click="openSingleBtn('refuse')">
                  <span class="align-middle">拒绝</span>
                  <el-tooltip content="拒绝的答卷，调查员无法修改" placement="top" effect="light">
                    <i v-if="isInterview" class="iconfont icon-shuoming text-theme-black-350 cursor-pointer align-middle"></i>
                  </el-tooltip>
                </el-button>
                <el-button size="small" type="primary" @click="openSingleBtn('agree')">通过</el-button>
              </div>
            </div>
            <div class="examine-btn" v-else>
              <div class="mr-4 flex-1 overflow-hidden">
                <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
              </div>
              <el-button @click="closeAuditDetailDialog">关闭</el-button>
            </div>
          </template>
          <div class="examine-btn" v-else>
            <div class="mr-4 flex-1 overflow-hidden">
              <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
            </div>
            <!-- 已处理tab -->
            <el-button @click="closeAuditDetailDialog">关闭</el-button>
          </div>
        </el-footer>
        <el-footer v-loading="btnsLoading" class="examine-btn bg-white" v-else v-show="audioSrc && !isSmartStore">
          <div class="w-full overflow-hidden">
            <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
          </div>
        </el-footer>
        <!-- 智能门店审核 -->
        <el-footer class="bg-white" v-if="isSmartStore">
          <div
            class="examine-btn"
            v-if="
              ((auditStatus == 0 || auditStatus == 12) && !preAudit) ||
              ((auditStatus == 0 || auditStatus == 12 || auditStatus == 8) && preAudit)
            "
          >
            <div class="mr-4 flex-1 overflow-hidden">
              <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
            </div>
            <div class="flex items-center">
              <el-button size="small" type="primary" @click="openSmartStore">审核</el-button>
            </div>
          </div>
          <div class="examine-btn" v-else>
            <div class="mr-4 flex-1 overflow-hidden">
              <audio-player :src="audioSrc" :fn="audioFileName" :auto-play="audioAutoPlay" @close="closeAudio" v-if="audioSrc" />
            </div>
            <div class="flex items-center">
              <el-button @click="closeAuditDetailDialog">关闭</el-button>
            </div>
          </div>
        </el-footer>
      </el-container>
    </el-drawer>
    <!-- 单题 通过 / 拒绝 / 驳回 弹层 【已审答卷功能】单题 修改审核功能 -->
    <audit-dialog :visible.sync="singleBtn.dialogVisible" :title="singleBtn.title" :type="singleBtn.type" :editAudit="singleBtn.editAudit" @confirm="confirmSingleExamineDialog" :confirmLoading.sync="singleBtn.loading"/>
    <!-- 智能门店审核弹层 -->
    <SmartStoreAudit :visible.sync="smartStoreVisible" :answerId="_currentId" :surveyFinishTime="surveyFinishTime" @add-audit-success="addAuditSuccess"/>
  </div>
</template>

<script>
import {
  auditOne,
  rejectQuestion,
  saveAnswer,
  reaudit // 已审答卷 功能使用--重审
} from '@/api/wenjuan/qualityControl'
import { auditOneMulti, rejectQuestionMulti } from '@/api/wenjuan/multiAudit'
const DetailEdit = () => import('@/components/survey-detail/DetailEdit') // 详情编辑
const DetailShow = () => import('@/components/survey-detail/DetailShow') // 详情显示
const MainQuestionsTable = () => import('@/components/survey-detail/MainQuestionsTable') // tab只看重点问题
const DimensionReport = () => import('@/components/survey-detail/DimensionReport') // tab维度报告
const DetailTaskFlow = () => import('@/components/survey-detail/DetailTaskFlow') // 审核流程
const EditRecord = () => import('@/components/survey-detail/EditRecord') // 修改记录
const SurveyDetailInfo = () => import('@/components/survey-detail/SurveyDetailInfo') // （右侧）答卷信息显示组件
const AudioPlayer = () => import('@/components/survey-detail/components/AudioPlayer') // 全局播放组件
import { getStore } from '@dygc/shared'
import SmartStoreAudit from './components/SmartStoreAudit'
const NewQuestionShow = () => import('@/components/survey-detail/NewQuestionShow') // 详情显示（新）
const NewQuestionEdit = () => import('@/components/survey-detail/NewQuestionEdit') // 详情编辑（新）
import AuditDialog from '@/components/survey-detail/components/AuditDialog'
import GlobalConfig from '@/global/config'
import { detail } from '@/api/wenjuan/answerList'

export default {
  components: {
    DetailEdit,
    MainQuestionsTable,
    DetailTaskFlow,
    EditRecord,
    DimensionReport,
    DetailShow,
    SurveyDetailInfo,
    AudioPlayer,
    SmartStoreAudit, //智能门店审核弹层
    NewQuestionShow,
    NewQuestionEdit,
    AuditDialog
  },
  props: {
    currentAnswerId: String,
    auditDetailVisible: Boolean,
    page: {
      type: Object,
      default: () => {}
    },
    answerDatas: Array,
    curAnswerIndex: Number,
    isEdit: {
      type: Boolean,
      default: false // 默认是查看
    },
    isApproved: {
      type: Boolean,
      default: false // 已审答卷标识，已审答卷可以修改答卷
    },
    myApproved: {
      type: Boolean,
      default: false // 【我审核的问卷】功能
    },
    showClose: {
      type: Boolean,
      default: false // 【我审核的问卷】功能
    },
    source: {
      type: String,
      default: '' // 统计报表来源
    },
    isDataDownload: {
      type: Boolean,
      default: false // 数据详情，维度报告功能
    },
    surveyFinishTime: {
      type: String,
      default: ''
    },
    disabledPrevNext:{
      type: Boolean,
      default: false // 隐藏上一页下一页按钮
    }
  },
  data() {
    return {
      visible: false,
      answerIdArray: [], //已获取的答卷id数组，上一条下一条使用
      currentTab: 'detail-new', // main / detail
      // 当前详情审核状态
      auditStatus: '', // 子组件MainQuestionsTable回传
      procTaskId: '', // 子组件MainQuestionsTable回传
      allowModifyAnswers: false, // 子组件MainQuestionsTable回传
      audited: false, // 子组件MainQuestionsTable回传
      // 判断是否是委托代理
      preAudit: getStore({ name: 'proxy_is_survey_proxy' }),
      saveBtn: {
        noLoading: false
      },
      channel: 0, // @/components/survey-detail/config/index.js  [2, 7, 9] 显示驳回

      // 单题通过/拒绝/驳回弹层
      singleBtn: {
        type: 'agree', // agree 通过  refuse 拒绝 reject驳回
        dialogVisible: false,
        title: '通过确认',
        // word: '通过',
        apiMsg: '',
        loading: false,
        editAudit: false
      },
      // singleExamineDialogForm: {
      //   desc: ''
      // },
      temp_index: 0, // 处理_curAnswerIndex不自增/减的问题
      temp_id: '',
      temp_data: [],
      keyEvent: null,
      editBtn: {
        loading: false
      },
      audioSrc: '',
      audioFileName: '',
      audioAutoPlay: false,
      smartStoreVisible: false, //智能门店审核弹层
      notUpdate: false, // 禁止触发多次刷新
      btnsLoading: false,
      channel: null,
      score: 0
    }
  },
  watch: {
    auditDetailVisible(val) {
      if (val) {
        this.visible = true
        this.open()
        this.getDetail()
      } else {
        this.visible = false
      }
    },
    curAnswerIndex(v) {
      this._curAnswerIndex = v
    }
  },
  computed: {
    isWuZhiShan() {
      return this.$store.getters.title.includes('五指山')
    },
    drawerTitle() {
      return this.isEdit || this.myApproved ? '审核(答卷ID：' + this._currentId + ')' : '答卷ID：' + this._currentId + ''
    },
    _currentId: {
      get() {
        return this.temp_id
      },
      set(v) {
        this.temp_id = v
        this.$emit('update:currentAnswerId', v)
        this.setChannel()
      }
    },
    _curAnswerIndex: {
      // 当前答卷在答卷数组中的索引位置
      get() {
        return this.temp_index
      },
      set(v) {
        this.temp_index = v
        this.$emit('update:curAnswerIndex', v)
      }
    },
    _answerDatas: {
      get() {
        return this.temp_data
      },
      set(v) {
        this.temp_data = v
        this.$emit('update:answerDatas', v)
      }
    },
    // 当前列表数据的 答卷id数组
    answerIds: {
      get() {
        return this._answerDatas?.map(item =>
          this.source == 'statistical' ? item.prop1 : this.source == 'datalist2' ? item[1] : item.id
        )
      }
    },
    userInfo() {
      return this.$store.getters.userInfo
    },
    isSmartStore() {
      return GlobalConfig.getIsSmartStore()
    },
    isInterview() {
      return this.channel === 2
    }
  },
  destroyed() {
    this.$emit('update:auditDetailVisible', false)
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    tabLeave(name) {
      if (name === 'dimension') {
        this.$refs.dimension.getData()
        return false
      }
    },
    getStatus(v) {
      this.auditStatus = v.status // 答卷状态
      this.procTaskId = v.procTaskId // 设置当前审核的流程任务id，在【我审核的问卷】功能中 使用
      this.allowModifyAnswers = v.allowModifyAnswers // 判断是否可编辑，在【我审核的问卷】功能中 使用
      this.audited = v.audited // 判断是否已审核过，在【我审核的问卷】功能中 使用
    },
    closeAuditDetailDialog() {
      if(this.notUpdate) return false
      this.audioSrc = ''
      this.audioFileName = ''
      this.closeVideo()
      // this.$emit('update:auditDetailVisible', false)
      this.close()
      document.body.onselectstart = () => { return true }
    },
    toPrev() {
      console.log('toPrev')
      this._curAnswerIndex = this._curAnswerIndex - 1
      // 数据还有上一条
      if (this._curAnswerIndex >= 0) {
        this._currentId = this.answerIds[this._curAnswerIndex]
        this.audioSrc = ''
      this.audioFileName = ''
        this.closeVideo()
      } else {
        console.log('===超出当前页面的数据，请前往上一页')
        let current = this.page.currentPage
        let c = current - 1
        // 加载上一页数据
        if (c > 0) {
          this.$emit('getPageData', c, res => {
            let data = (res.data && res.data.data) || {}
            if (this.source == 'statistical') {
              data = res.data && res.data.data.baseTableData
            }
            this.page.total = data.total
            this.page.currentPage = data.current
            this.page.pageSize = data.size

            this._answerDatas = data.records || []
            this._curAnswerIndex = this._answerDatas.length - 1
            this._currentId = this._answerDatas[this._curAnswerIndex].id
            if (this.source == 'statistical') {
              //统计报表部分查看答卷详情
              this._currentId = this._answerDatas[this._curAnswerIndex].prop1
            }
            if (this.source == 'datalist2') {
              this._currentId = this._answerDatas[this._curAnswerIndex][1]
            }
          })
          this.audioSrc = ''
          this.audioFileName = ''
          this.closeVideo()
          // 提示 已经是第一页
        } else {
          this._curAnswerIndex = 0
          this.$message.warning('已是第一条')
        }
      }
       this.getDetail()
    },
    toNext(flag) {
      this.notUpdate = false
      if(this.disabledPrevNext) { // 无上下页
        this._curAnswerIndex = 0
        this.closeAuditDetailDialog()
        return 
      }
      console.log('toNext')
      this._curAnswerIndex = this._curAnswerIndex + 1
      // 数据还有下一条
      if (this._curAnswerIndex <= this.answerIds.length - 1) {
        this._currentId = this.answerIds[this._curAnswerIndex]
        this.audioSrc = ''
        this.audioFileName = ''
        this.closeVideo()
        // 数据到当前分页的最后一条；但是不知道下页是否还有数据
      } else {
        console.log('===超出当前页面的数据，请前往下一页')
        let current = this.page.currentPage
        this.$emit(
          'getPageData',
          ++current,
          res => {
            // 设置列表数据
            let data = (res.data && res.data.data) || {}
            if (this.source == 'statistical') {
              data = res.data && res.data.data.baseTableData
            }
            let records = (data && data.records) || []
            if (records.length == 0) {
              this.$message.warning('已是最后一条')
              this._curAnswerIndex = this.answerDatas.length - 1 // 前一次的数据长度 - 1
              this._currentId = this.answerDatas[this.answerDatas.length - 1]?.id
              if (this.source == 'statistical') {
                //统计报表部分查看答卷详情
                this._curAnswerIndex = this._answerDatas.length - 1
                this._currentId = this.answerDatas[this.answerDatas.length - 1]?.prop1
              }
              // 前一次的数据长度 - 1
              if (this.source == 'datalist2') {
                this._curAnswerIndex = this._answerDatas.length - 1
                //统计报表部分查看答卷详情
                this._currentId = this.answerDatas[this.answerDatas.length - 1]?.[1]
              }
              if (flag === 'examine') {
                // 最后一条关闭
                this._curAnswerIndex = 0
                this.closeAuditDetailDialog()
                this.notUpdate = true
              }
            } else {
              // 有数据时，才设置分页
              this.page.total = data.total
              this.page.currentPage = data.current
              this.page.pageSize = data.size
              this._answerDatas = data.records || []
              // 新页默认选第一个
              this._curAnswerIndex = 0
              this._currentId = this._answerDatas[0].id
              if (this.source == 'statistical') {
                //统计报表部分查看答卷详情
                this._currentId = this._answerDatas[0].prop1
              }
              if (this.source == 'datalist2') {
                //统计报表部分查看答卷详情
                this._currentId = this._answerDatas[0][1]
              }
              this.audioSrc = ''
              this.audioFileName = ''
              this.closeVideo()
            }
          },
          flag
        )
      }
       this.getDetail()
    },
    setChannel() {
      if (this.source == 'statistical' || this.source == 'datalist2') return //统计报表不显示【驳回】按钮，且_answerDatas中无channel值
      // 控制【驳回】按钮显示
      if (this._answerDatas && this._answerDatas.length > 0) {
        this._answerDatas.find(item => {
          return item.id === this._currentId
        })
        this.channel = this._answerDatas.find(item => {
          return item.id === this._currentId
        }).channel
      }
    },
    open() {
      this._curAnswerIndex = this.curAnswerIndex
      this.temp_id = this.currentAnswerId
      this._answerDatas = this.answerDatas
      this.setChannel()
      // this.addKeyDownPrevNext()
    },
    close() {
      this.$emit('update:auditDetailVisible', false)
      this.visible = false
      // 刷新 整个列表
      this.$emit('refreshCurrentTableData')
      this.removeKeyDownPrevNext()
      // this._curAnswerIndex = 0 // 重置到第一条
    },
    // ========⬇==== 单项质控 弹层=====⬇=====
    // 单项质控 取消 按钮
    // closeSingleExamineDialog() {
    //   this.singleBtn.dialogVisible = false
    //   this.singleExamineDialogForm.desc = ''
    //   this.$refs['singleExamineDialogForm'].resetFields()
    // },
    setParams(initParams = {}) {
      // 整理数据 多媒体资料字段优化
      const ds = this.$refs['surveyDetail']
      const param = initParams
      const mediaArr = ['audioFilesArr', 'imageFilesArr', 'videoFilesArr']
      const mediaKey = ['audioFiles', 'imageFiles', 'videoFiles']
      mediaArr.forEach((item, idx) => {
        if (Array.isArray(ds[item])) {
          param[mediaKey[idx]] = ds[item]
        }
      })
      return param
    },
    // 单项质控 确认 按钮（通过、拒绝、驳回）
    async confirmSingleExamineDialog(data) {
      if(this.singleBtn.editAudit) {  //修改审核 - 调用修改审核方法
        this.confirmApprovedExamineDialog(data)
        return
      }
      // this.$refs['singleExamineDialogForm'].validate(valid => {
        // if (valid) {
          // this.singleBtn.noLoading = true
          let answerContent = []
          // 允许编辑时，两种情况
          if(this.currentTab === 'detail-new' && (this.allowModifyAnswers || this.isEdit)) {
            try {
              answerContent = await this.$refs.newQuestionEdit.getEditAnswer()
            }catch(e) {
              this.$message.error(e.message?.message)
              return
            } finally {
              this.singleBtn.loading = false
            }
          }

          if(this.currentTab ==='detail') {
            answerContent = this.$refs['details'].xArr
          }
          const p = this.setParams({
            id: this._currentId,
            answerContent: answerContent || [], // 获取 详情组件里的 开放题答案等
            preAudit: getStore({ name: 'proxy_is_survey_proxy' }) // 2021-1-25 委托代理
          })
          let api = ''
          // 通过 拒绝
          if (this.singleBtn.type === 'agree' || this.singleBtn.type === 'refuse') {
            if (this.singleBtn.type === 'refuse') {
              p.auditCause = data
            }else {
              p.auditDescription = data
            }
            p.pass = this.singleBtn.type === 'agree'
            api = auditOne
            // 【我审核的问卷】功能
            if (this.myApproved) {
              p.procTaskId = this.procTaskId
              api = auditOneMulti
            }
          }
          // 驳回
          if (this.singleBtn.type === 'reject') {
            p.auditCause = data
            api = rejectQuestion
            // 【我审核的问卷】功能
            if (this.myApproved) {
              p.procTaskId = this.procTaskId
              api = rejectQuestionMulti
            }
          }
          api(p)
            .then(res => {
              if (res.data.code === 0) {
                this.$message.success(this.singleBtn.apiMsg)
                this.singleBtn.dialogVisible = false
                if(this.currentTab === 'detail') {
                  this.$refs['details'].xArr = [] // 重制 修改问题
                }
                this.toNext('examine') // examine 标记为：操作后
              } else {
                this.$message.error(res.data.msg || '审核失败')
              }
            })
            .catch(e => {
              this.$message.error(e.message || '审核失败')
              if (e.message !== '系统未知错误,请反馈给管理员') {
                this.singleBtn.dialogVisible = false
                // this.getTableData(this.isActive) // todo 刷新列表
              }
            })
            .finally(() => {
              this.singleBtn.loading = false
              // this.currentIdx = 0 // todo
            })
        // }
      // })
    },
    openSingleBtn(type) {
      if (type === 'refuse') {
        this.singleBtn.title = '拒绝确认'
        this.singleBtn.type = 'refuse'
        // this.singleBtn.word = '拒绝'
        this.singleBtn.apiMsg = '答卷审核-拒绝操作成功'
      } else if (type === 'reject') {
        this.singleBtn.title = '驳回确认'
        this.singleBtn.type = 'reject'
        // this.singleBtn.word = '驳回'
        this.singleBtn.apiMsg = '答卷审核-驳回操作成功'
      } else {
        this.singleBtn.title = '通过确认'
        this.singleBtn.type = 'agree'
        // this.singleBtn.word = '通过'
        this.singleBtn.apiMsg = '答卷审核-通过操作成功'
      }
      this.singleBtn.dialogVisible = true
    },
    // 保存 按钮
    async saveBtnEvent() {
      this.saveBtn.noLoading = true
      let answerContent = []

      if(this.currentTab === 'detail') {
        answerContent = this.$refs['details'].xArr
      }

      if(this.currentTab === 'detail-new') {
        try {
          answerContent = await this.$refs.newQuestionEdit.getEditAnswer()
        }catch(e) {
          this.$message.error(e.message?.message)
          return
        } finally {
          this.saveBtn.noLoading = false
        }
      }
      const p = this.setParams({
        id: this._currentId,
        answerContent: answerContent || [] // 获取 详情组件里的 开放题答案等
      })
      saveAnswer(p)
        .then(res => {
          if (res.status == 200) {
            this.$message.success('保存成功')
            if(this.currentTab === 'detail') {
              this.$refs['details'].xArr = [] // 重制 修改问题
              this.$refs['details'].onRefresh(this._currentId)
            }
          } else {
            this.$message.error('保存失败')
          }
        })
        .catch(e => {
          this.$message.error('保存失败,' + e.message)
          if (e.message !== '系统未知错误,请反馈给管理员') {
            // this.getTableData(this.isActive) // 刷新列表
          }
        })
        .finally(() => {
          this.saveBtn.noLoading = false
        })
    },
    //左右快捷键控制上一条下一条
    // addKeyDownPrevNext() {
    //   let _this = this
    //   this.keyEvent = function (event) {
    //     var e = event || window.event || arguments.callee.caller.arguments[0]
    //     if (e && (e.keyCode == 37 || e.keyCode == 38) && _this.auditDetailVisible == true) {
    //       //上,左
    //       _this.toPrev()
    //     }
    //     if (e && (e.keyCode == 39 || e.keyCode == 40) && _this.auditDetailVisible == true) {
    //       //下,右
    //       _this.toNext()
    //     }
    //   }
    //   document.addEventListener('keydown', this.keyEvent)
    // },
    removeKeyDownPrevNext() {
      document.removeEventListener('keydown', this.keyEvent)
    },

    // 【已审答卷】功能
    detailLoadingEnd(isLoading) {
      this.editBtn.loading = isLoading
    },
    openApprovedBtn() {
      this.singleBtn.title = '提醒',
      this.singleBtn.type = this.auditStatus == 1?'refuse':'agree',
      this.singleBtn.apiMsg = '答卷审核修改成功',
      this.singleBtn.dialogVisible = true,
      this.singleBtn.editAudit = true
    },
    async confirmApprovedExamineDialog(data) {
      // this.$refs['approvedExamineDialogForm'].validate(valid => {
        // if (valid) {
          // this.approvedBtn.noLoading = true
          let answerContent = []

          if(this.currentTab === 'detail') {
            answerContent = this.$refs['details'].xArr
          }

          if(this.currentTab === 'detail-new') {
            try {
              answerContent = await this.$refs.newQuestionEdit.getEditAnswer()
            }catch(e) {
              this.$message.error(e.message?.message)
              return
            } finally {
              this.singleBtn.loading = false
            }
          }
          const p = this.setParams({
            id: this._currentId,
            pass: this.singleBtn.type === 'agree',
            answerContent, // 获取 详情组件里的 开放题答案等
            preAudit: getStore({ name: 'proxy_is_survey_proxy' }) // 2021-1-25 委托代理
          })
          if(this.singleBtn.type === 'agree') {
            p.auditDescription = data
          } else {
            p.auditCause = data
          }
          reaudit(p)
            .then(res => {
              if (res.status == 200) {
                // status 200时，code不等于0时 有错误提示
                if(res.data.code !== 0) {
                  this.$message.error(res.data.msg || '操作失败')
                  return
                }
                this.$message.success(this.singleBtn.apiMsg)
                this.singleBtn.dialogVisible = false
                if(this.currentTab === 'detail') {
                  this.$refs['details'].xArr = [] // 重制 修改问题
                }
                this.toNext('examine')
              } else {
                this.$message.error(res.data.msg && '操作失败')
              }
            })
            .catch(e => {
              this.$message.error(e.message || '操作失败')
              if (e.message !== '系统未知错误,请反馈给管理员') {
                this.singleBtn.dialogVisible = false
              }
            })
            .finally(() => {
              this.singleBtn.loading = false
            })
        // }
      // })
    },
    closeVideo() {
      if (this.$refs.surveyDetail) {
        this.$refs.surveyDetail.videoUrl = ''
      }
    },
    audioPlayHandle(item) {
      this.audioSrc = item.url
      this.audioFileName = item.fileName
      this.audioAutoPlay = true
    },
    closeAudio() {
      this.audioSrc = ''
      this.audioFileName = ''
      this.audioAutoPlay = false
    },
    openSmartStore() {
      this.smartStoreVisible = true
    },
    //智能门店添加审核描述成功后的调用
    addAuditSuccess() {
      const p = this.setParams({
        id: this._currentId,
        answerContent: this.$refs['details']?.xArr || [], // 获取 详情组件里的 开放题答案等
        preAudit: getStore({ name: 'proxy_is_survey_proxy' }), // 2021-1-25 委托代理
        auditDescription: '',
        pass: true
      })

      auditOne(p)
        .then(res => {
          if(res.data.code !== 0) {
            this.$message.error(res.data.msg || '审核失败')
            return
          }
          this.$message.success('审核成功')
          if(this.currentTab === 'detail') {
            this.$refs['details'].xArr = [] // 重制 修改问题
          }
          this.toNext('examine')
        })
        .catch(e => {
          this.$message.error(e.message || '审核失败')
          if (e.message !== '系统未知错误,请反馈给管理员') {
          }
        })
        .finally(() => {
          this.smartStoreVisible = false
        })
    },
    // 禁止勾选文字
    notCopy() {
      document.body.onselectstart = () => { return false }
    },
    getDetail() {
      this.btnsLoading = true
      detail(this._currentId).then(res => {
        console.log(res.data.data.score,"res.data.data.score")
        this.score = res.data.data.score
        this.channel = res.data.data.channel
      }).finally(()=> {
        this.btnsLoading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
// 单个答卷 审核
.answer-one-item {
  .el-footer {
    @apply px-0;
  }
  .examine-btn {
    height: 60px;
    z-index: 1000;
    border-top: 1px solid #e7e7eb;
    @apply px-4 border-border-gray flex items-center justify-between;
  }
  .meta-label {
    @apply flex border border-solid border-danger text-danger;
    border-radius: 2px;
    font-weight: 600;
    font-size: 10px;
    height: 18px;
    line-height: 18px;
    padding: 1px 4px;
    letter-spacing: 0;
    transform: scale(0.83);
  }
}
.prevNext {
  position: absolute;
  left: -85px;
  top: 20px;
  .el-button {
    padding: 8px 15px;
    // color: #000;
    // background-color: #fff;
    // border-color: #fff;
    // border-radius: 3px;
    display: block;
  }
  .el-button + .el-button {
    margin-left: 0px;
    margin-top: 10px;
  }
}

.el-icon-warning {
  color: orange;
  margin-right: 6px;
  font-size: 20px;
  position: relative;
  top: 1px;
}

.footer {
  position: relative;
  bottom: 0;
  height: 64px;
  background: #ffffff;

  span {
    float: left;
    opacity: 0.85;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 64px;
    margin-left: 24px;
  }

  .video {
    float: left;
    width: 663px;
    height: 32px;
    margin-left: 2px;
    // margin-top: 16px;
    opacity: 0.1;
    border-radius: 16px;
    @apply bg-theme;
  }
  button {
    float: left;
    width: 88px;
    height: 32px;
    font-size: 14px;
    text-align: center;
    line-height: 32px;
    margin-left: 12px;
    margin-top: 16px;
    border-radius: 2px;
    background: #ffffff;
  }
  .bt1 {
    color: #ffffff;
    margin-left: 141px;
    @apply bg-theme;
  }
  .bt2 {
    border: 1px solid;
    @apply border-theme text-theme;
  }
  .bt3 {
    border: 1px solid #e34152;
    color: #e34152;
  }
  .bt4 {
    margin-left: 0;
    border: none;
    @apply text-theme;
  }
}
.el-main {
  margin-right: 26px;
}
</style>
